import React from "react";
import { servicios } from "../properties";
import { goTo } from "../tools";
import firebase from "firebase";

const modal1 = "#modal-ayuda-registro";
let contador = 0;
let dataStorage;
let dataStorage2;

export default class MensajeAyuda extends React.Component {
  constructor(props) {
    super(props);
    dataStorage = JSON.parse(localStorage.getItem("dataFirebase"));
    dataStorage2 = JSON.parse(localStorage.getItem("dataFirebase2"));
    
    this.state = {
      btnAyuda: false,
      txtBtnAyuda: "Ayuda",
      btnContinuar: "Continuar",
      btnSalir: "Salir",
      texto1: "Texto1",
      texto2: "Texto2",
      texto3: "Texto3",
      titulo1: "Titulo1",
      titulo2: "Titulo2"
    };
  }

  componentDidMount = () => {
    if (this.dataStorage === undefined) {
      dataStorage = JSON.parse(localStorage.getItem("dataFirebase"));
    }
    if (this.dataStorage2 === undefined) {
      dataStorage2 = JSON.parse(localStorage.getItem("dataFirebase2"));
    }
  };

  abrirmodal = () => {
    setTimeout(() => {
      $(modal1).modal({ backdrop: "static", keyboard: false });
    }, 1000);
  };

  abrirWhats = () => {
    const dataStorage2 = JSON.parse(localStorage.getItem("dataFirebase2"));
    const downloadUrl = dataStorage2.link;
    var createA = document.createElement("a");
    createA.setAttribute("target", "_blank");
    createA.setAttribute("href", downloadUrl);
    createA.click();
    this.onClose();
  };

  cancelar = () => {
    localStorage.removeItem("aceptarAviso");
    localStorage.removeItem("mediosElectronicos");

    this.onClose();

    firebase
      .database()
      .ref("portales/portalReingenieria")
      .once("value")
      .then((oValue) => {
        var data = oValue.val();
        if (!data) {
          goTo("login");
        } else {
          window.location.assign(servicios.dominioReingenieria);
        }
      });
  };

  onClose = (e) => {
    $(modal1).modal("hide");
    contador = 0;
    console.log("Close modal");
    this.props.onClose && this.props.onClose(e);
  };

  render() {
    if (this.props.show) {

      if (this.dataStorage === undefined) {
        dataStorage = JSON.parse(localStorage.getItem("dataFirebase"));
      }
      if (this.dataStorage2 === undefined) {
        dataStorage2 = JSON.parse(localStorage.getItem("dataFirebase2"));
      }

      const titulo1 =
        this.props.typeModal === "regresar"
          ? dataStorage.titulo1
          : dataStorage.titulo2;
      const texto1 =
        this.props.typeModal === "regresar"
          ? dataStorage.texto1.substring(0, 50)
          : dataStorage.texto2;
      const texto2 = this.props.typeModal === "regresar" ? dataStorage.texto1.substring(51, 67) : "";
      const texto3 = this.props.typeModal === "regresar" ? dataStorage.texto1.substring(68, 108) : "";
      const btnContinuar = dataStorage.botonContinuar;
      const txtBtnAyuda = dataStorage.botonAyuda;
      const btnSalir = dataStorage.botonSalir;

      return (
        <div
          className="modal show"
          id="modal-ayuda-registro"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-ayuda-registro"
        >
          <div className="modal-content modal-content-ayuda">
            <img
              alt=""
              id="img-animation"
              src={require("../assets/animation_640_modal.gif")}
            />
            <div id="text-center">
              <h4 id="text-title-ayuda">{titulo1}</h4>
            </div>

            <div id="txt-black-ayuda">
              <label id="txt-mensaje">
                {texto1} <span id="txtTiltleModal">{texto2}</span> {texto3}
              </label>
            </div>

            <div className="footer-modal-ayuda">
              <button
                type="button"
                id="btn-continuar-ayuda"
                onClick={this.onClose}
              >
                {btnContinuar}
              </button>
              <button
                type="button"
                id="btn-solicitar-ayuda"
                onClick={this.abrirWhats}
              >
                {txtBtnAyuda}
              </button>
              {this.props.typeModal === "regresar" && (
                <button
                  type="button"
                  id="btn-salir-ayuda"
                  onClick={this.cancelar}
                >
                  {btnSalir}
                </button>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modal-ayuda-registro/modal-ayuda-registro.cmpt.js